import React, { useState, useEffect } from 'react';
import { getLawyerSpecialties } from '../../services/api';

export default function SpecialtySelector({ onSpecialtyChange, isLawyer = false }) {
  const [specialties, setSpecialties] = useState([]);
  const [selectedSpecialties, setSelectedSpecialties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSpecialties = async () => {
      try {
        const response = await getLawyerSpecialties();
        setSpecialties(response);
      } catch (error) {
        console.error('Error fetching specialties:', error);
        // Fallback
        setSpecialties([
          { id_especialidad: '1', especialidad_name: 'Derecho Civil' },
          { id_especialidad: '2', especialidad_name: 'Derecho Penal' },
          { id_especialidad: '3', especialidad_name: 'Derecho Familiar' },
          { id_especialidad: '4', especialidad_name: 'Derecho Mercantil' },
          { id_especialidad: '5', especialidad_name: 'Derecho Laboral' },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchSpecialties();
  }, []);

  const handleSpecialtyToggle = specialtyId => {
    const newSelectedSpecialties = selectedSpecialties.includes(specialtyId)
      ? selectedSpecialties.filter(id => id !== specialtyId)
      : [...selectedSpecialties, specialtyId];

    setSelectedSpecialties(newSelectedSpecialties);

    if (onSpecialtyChange) {
      onSpecialtyChange(newSelectedSpecialties);
    }
  };

  if (loading) {
    return (
      <div className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-500">
        Cargando especialidades...
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <label className={`text-xs mb-1 ${isLawyer ? 'text-gray-300' : 'text-gray-500'}`}>
        Especialidades *
      </label>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {specialties.map(specialty => (
          <label
            key={specialty.id_especialidad}
            className={`flex items-center space-x-2 p-2 rounded-lg border cursor-pointer transition-colors ${
              selectedSpecialties.includes(specialty.id_especialidad)
                ? isLawyer
                  ? 'bg-blue-600 border-blue-500 text-white'
                  : 'bg-blue-100 border-blue-500 text-blue-900'
                : isLawyer
                  ? 'bg-transparent border-gray-400 text-white hover:border-gray-300'
                  : 'bg-white border-gray-300 text-gray-900 hover:border-gray-400'
            }`}
          >
            <input
              type="checkbox"
              checked={selectedSpecialties.includes(specialty.id_especialidad)}
              onChange={() => handleSpecialtyToggle(specialty.id_especialidad)}
              className="sr-only"
            />
            <span className="text-sm">{specialty.especialidad_name}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
